import { TipoPagamentoCeler } from './../shared/models/pagamento-pix-celer-model';
import { Pipe, PipeTransform } from '@angular/core';
import { StatusLinkPagamentoCelerEnum } from '../shared/models/pagamento-pix-celer-model';

const StatusPagamentoPipeMap = {
  [TipoPagamentoCeler.PIX]: {
    [StatusLinkPagamentoCelerEnum.PAGO]: 'Pix recebido e aguardando processamento',
    [StatusLinkPagamentoCelerEnum.AGUARDANDO_PAGAMENTO]: 'Aguardando Pagamento do QRCode'
  },
  [TipoPagamentoCeler.CARTAO]: {
    [StatusLinkPagamentoCelerEnum.PAGO]: 'Pagamento com cartão recebido e aguardando processamento',
    [StatusLinkPagamentoCelerEnum.AGUARDANDO_PAGAMENTO]: 'Aguardando Pagamento com Cartão'
  }
};

@Pipe({
  name: 'statusPagamentoCeler'
})
export class StatusPagamentoCelerPipe implements PipeTransform {

  transform(value: StatusLinkPagamentoCelerEnum, tipoPagamento: TipoPagamentoCeler): string {
    if (value && tipoPagamento) {
      return StatusPagamentoPipeMap[tipoPagamento][value];
    }

    if (value && tipoPagamento === null) {
      return 'Link gerado';
    }

    return '';
  }

}
